// extracted by mini-css-extract-plugin
export default {"dashHistory":"History_dashHistory__mWrS0","listItems":"History_listItems__HKmyB","active":"History_active__+i2yZ"};